'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownItemIcon = exports.DropdownItem = exports.DropdownItemContainer = exports.Dropdown = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bodyClick = require('../../decorators/bodyClick');

var _bodyClick2 = _interopRequireDefault(_bodyClick);

var _Icon = require('../../components/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Link = require('../../components/Link');

var _Link2 = _interopRequireDefault(_Link);

require('./styles.sass');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
 * How long does it take a dropdown to animate?
 * That sounds like a lightbulb joke, hah!
 * @type {Number}
 */
var TRANSITION_DURATION = 200;

/**
 * The dropdown component itself. It needs a button
 * which will be wrapped so the dropdown can be displayed relative to it.
 *
 * When `isOpen` is undefined, the component is uncontrolled and manages
 * it's own state. If not, then it's controlled.
 */
var Dropdown = exports.Dropdown = (_dec = (0, _bodyClick2.default)(), _dec(_class = (_class2 = function (_Component) {
  (0, _inherits3.default)(Dropdown, _Component);

  function Dropdown() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Dropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Dropdown.__proto__ || (0, _getPrototypeOf2.default)(Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  /**
   * Initial state.
   */


  (0, _createClass3.default)(Dropdown, [{
    key: 'onButtonClick',


    /**
     * When the button is clicked (that is, when the wrapping span is clicked),
     * if controlled, trigger the callback. If not, toggles internal `isOpen` state.
     */
    value: function onButtonClick(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!this.isControlled()) {
        this.toggleDropdown();
      } else {
        if (this.props.onButtonClick) {
          this.props.onButtonClick();
        }
      }
    }

    /**
     * Determines if this dropdown is controlled.
     */

  }, {
    key: 'isControlled',
    value: function isControlled() {
      return this.props.isOpen !== undefined;
    }

    /**
     * If configured, dismisses the dropdown.
     */

  }, {
    key: 'onBodyClick',
    value: function onBodyClick(e) {
      if (this.refs.togglerButton) {
        var domNode = this.refs.togglerButton;
        if (domNode && domNode.contains(e.target)) {
          return;
        }
      }

      if (this.isControlled()) {
        if (this.props.onRequestClose && this.props.isOpen) {
          this.props.onRequestClose();
        }
        return;
      }

      if (this.state.isOpen && this.props.autoDismiss) {
        this.toggleDropdown();
      }
    }

    /**
     * Toggles the internal `isOpen` state.
     */

  }, {
    key: 'toggleDropdown',
    value: function toggleDropdown() {
      this.setState({ isOpen: !this.state.isOpen });
    }

    /**
     * Renders the dropdown.
     */

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          button = _props.button,
          children = _props.children,
          position = _props.position,
          isOpen = _props.isOpen;

      var dropdownIsOpen = !this.isControlled() ? this.state.isOpen : isOpen;
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('Dropdown') },
        button && _react2.default.createElement(
          'span',
          { onClick: this.onButtonClick, ref: 'togglerButton' },
          button
        ),
        _react2.default.createElement(
          _reactAddonsCssTransitionGroup2.default,
          {
            transitionName: 'DropdownAnimation',
            transitionEnterTimeout: TRANSITION_DURATION,
            transitionLeaveTimeout: TRANSITION_DURATION
          },
          dropdownIsOpen && _react2.default.createElement(
            'ul',
            { className: (0, _classnames2.default)('DropdownContent', position) },
            children
          )
        )
      );
    }
  }]);
  return Dropdown;
}(_react.Component), (_applyDecoratedDescriptor(_class2.prototype, 'onButtonClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onButtonClick'), _class2.prototype)), _class2)) || _class);


Dropdown.defaultProps = {
  position: 'left',
  autoDismiss: true
};

Dropdown.propTypes = {
  position: _propTypes2.default.string,
  button: _propTypes2.default.node,
  isOpen: _propTypes2.default.bool,
  autoDismiss: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  onButtonClick: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func
};

/**
 * Used by `DropdownItem`.
 */
var DropdownItemContainer = exports.DropdownItemContainer = function DropdownItemContainer(_ref2) {
  var children = _ref2.children;
  return _react2.default.createElement(
    'li',
    { className: 'DropdownItemContainer' },
    children
  );
};

DropdownItemContainer.propTypes = {
  children: _propTypes2.default.node.isRequired
};

/**
 * A regular dropdown item.
 */
var DropdownItem = function DropdownItem(_ref3) {
  var children = _ref3.children,
      className = _ref3.className,
      active = _ref3.active,
      other = (0, _objectWithoutProperties3.default)(_ref3, ['children', 'className', 'active']);
  return _react2.default.createElement(
    DropdownItemContainer,
    null,
    _react2.default.createElement(
      _Link2.default,
      (0, _extends3.default)({ className: (0, _classnames2.default)('DropdownItem', className, active && 'is-active') }, other),
      children
    )
  );
};

exports.DropdownItem = DropdownItem;
DropdownItem.propTypes = {
  className: _propTypes2.default.string,
  active: _propTypes2.default.bool,
  children: _propTypes2.default.node
};

/**
 * A dropdown item icon. Nice.
 */
var DropdownItemIcon = exports.DropdownItemIcon = function DropdownItemIcon(_ref4) {
  var name = _ref4.name,
      material = _ref4.material,
      children = _ref4.children;
  return _react2.default.createElement(
    'span',
    { className: 'DropdownItemIcon' },
    name && _react2.default.createElement(_Icon2.default, { name: name, className: 'DropDownItemIcon__icon', material: material }),
    children
  );
};

DropdownItemIcon.propTypes = {
  name: _propTypes2.default.string,
  material: _propTypes2.default.bool,
  children: _propTypes2.default.node
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/Dropdown/index.js
// module id = 616
// module chunks = 0